/* eslint-disable */
import { v4 as uuidV4 } from 'uuid';
export class CentroAtivoRecurso {
  constructor () {
    this.ativo_recurso_id = uuidV4()
    this.descricao = ''

  }
}
